// components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // A cross-page anchor (e.g. /career-centers#book) should land on the
    // section, not the top of the page. Without this the scroll below wins
    // and the hash is silently ignored.
    if (hash) {
      const id = hash.slice(1);
      // One frame, so the incoming route has laid out before we measure.
      const frame = requestAnimationFrame(() => {
        const target = document.getElementById(id);
        if (target) target.scrollIntoView({ block: "start" });
        else window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      });
      return () => cancelAnimationFrame(frame);
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto" // Or "smooth" if you want scroll animation
    });

    return undefined;
  }, [pathname, hash]);

  return null; // this component doesn't render anything
};

export default ScrollToTop;
